<div class="CeIntroDialog">
    <h1 class="CeIntroDialog-header">Try ChargEye beta</h1>
    <div class="CeIntroDialog-content">
        <p>
            We're working on a brand new version of ChargEye. While most features still live in ChargEye classic, you
            can already explore the new charging network view and a few other early features.
        </p>
        <mat-checkbox [(ngModel)]="doNotShowCheck">Do not show this message again</mat-checkbox>

        <section class="example-section"></section>
    </div>
    <div class="CeIntroDialog-footer">
        <button class="CeIntroDialog-button" (click)="dialogAction(false)">Stay here</button>
        <button class="CeIntroDialog-button CeIntroDialog-button--primary" (click)="dialogAction(true)">
            Continue to ChargEye beta
        </button>
    </div>
</div>
